import axios from "../axiosPlugin.js";

const _ADV_COUPON_TYPE_API = "/api/advanceCouponType";
const _COUPON_EXCHANGE_API = "/api/couponExchange";

/* Advance Coupon services */
export const getAdvCouponTypeListService = data => {
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/list`,
    method: "get",
    data: { data },
  });
};

export const getAdvCouponTypeDetailService = (data, loading = true, isDefaultAlertTips = false) => {
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/detail/${data.id}`,
    method: "get",
    data: {
      loading,
      isDefaultAlertTips,
    },
  });
};

export const addAdvCouponTypeService = data => {
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateAdvCouponTypeService = data => {
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/update`,
    method: "post",
    data: { data },
  });
};

export const delAdvCouponTypeService = data => {
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/delete/${data.id}`,
    method: "get",
    data: { data },
  });
};

export const advCouponTypeUpdateApproveService = data => {
  // let queryString = data.cinemaId ? "cinemaId=" + data.cinemaId : "brandId=" + data.brandId;
  return axios({
    url: `${_ADV_COUPON_TYPE_API}/updateApprove`,
    method: "post",
    data: {
      data
    },
  });
};

/* Coupon Exchange services */
export const getCouponExchangeListService = data => {
  return axios({
    url: `${_COUPON_EXCHANGE_API}/list`,
    method: "get",
    data: { data },
  });
};

export const addAllCouponExchangeService = data => {
  return axios({
    url: `${_COUPON_EXCHANGE_API}/saveAllCouponExchangeByCount`,
    method: "get",
    data: { data },
  });
};

export const updateAllCouponExchangeService = data => {
  return axios({
    url: `${_COUPON_EXCHANGE_API}/updateAllCouponExchangeStatusByCount`,
    method: "get",
    data: { data },
  });
};

export const updateStatusService = data => {
  const { id, status } = data;

  return axios({
    url: `${_COUPON_EXCHANGE_API}/updateStatus?id=${id}&status=${status}`,
    method: "post",
    data: { data },
  });
};